import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { withStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';

import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { animateScroll as scroll, scroller } from 'react-scroll'; // eslint-disable-line
import * as QueryString from 'query-string';
import { Helmet } from 'react-helmet';
import Geocode from 'react-geocode';

import NavBar from '../../nav/NavBarMapCollapse';
import MapComponent from './MapComponent';
import MapSearchPanel from './MapSearchPanel';
import ListComponent from './ListComponent';
import ListSearchPanel from './ListSearchPanel';
import { getTrainings } from '../../../shared/requests/EventRequests';
import geteventTypes from '../../../shared/requests/CertRequests';
import { listTrainers } from '../../../shared/requests/UserRequests';
import MySnackbarContentWrapper from '../../../shared/snackbars/MySnackbarContentWrapper';

import loadGMaps from '../LoadGMaps';

import {
  days,
} from '../../../shared/Mappings';
import {
  validAttendanceTypeByCode,
  validLanguageByCode,
  validOrderingByCode,
  // validEventTypeByCode,
} from '../../../shared/Helpers';
import {
  GOOGLE_MAPS_API_KEY,
} from '../../../shared/Constants';

import MyPopOver from './PopOver';

const DEFAULT_ZOOM = 6;

const styles = theme => ({
  layout: {
    flexGrow: 1,
    display: 'flex',
  },
  content: {
    flexGrow: 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  wrapperOpen: {
    width: '100%',
    [theme.breakpoints.up(1240)]: {
      paddingLeft: 420,
    },
    transition: theme.transitions.create('padding-left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  wrapperClosed: {
    width: '100%',
    paddingLeft: 0,
    transition: theme.transitions.create('padding-left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  popoverSection: {
    padding: theme.spacing(2),
  },
});


class Finder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      pageLoading: false,
      attendanceType: 'online',
      listView: true,
      open: true,
      events: [],
      eventType: -1,
      eventTypes: [],
      trainer: -1,
      trainers: [],
      language: 'any',
      address: '',
      coords: {
        latitude: 45.5,
        longitude: -122.6,
      },
      zoom: DEFAULT_ZOOM,
      openWindow: 0,
      day: 0,
      userTimezone: moment.tz.guess(),
      page: 0,
      morePagesAvailable: true,
      ordering: 'time',
      showTimezoneField: false,
      pageSize: '20',
      expanded: false,
      startDate: '',
      endDate: '',
      popupOpen: false,
      dependsOnText: '',
      dependsOnCheckbox: '',
      dependsChecked: false,
      popupAnchor: null,
      dependsLink: '',
      queryHasChanged: false,
    };

    this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
    this.handleDrawerClose = this.handleDrawerClose.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleViewToggle = this.handleViewToggle.bind(this);
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
    this.getTrainings = this.getTrainings.bind(this);
    this.setCenter = this.setCenter.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.handleLocationSelect = this.handleLocationSelect.bind(this);
    this.onOpenMapWindow = this.onOpenMapWindow.bind(this);
    this.onCloseMapWindow = this.onCloseMapWindow.bind(this);
    this.onResultClick = this.onResultClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.getNextPage = this.getNextPage.bind(this);
    this.handleDayChange = this.handleDayChange.bind(this);
    this.handleAttendanceTypeChange = this.handleAttendanceTypeChange.bind(this);
    this.handleTimezoneChange = this.handleTimezoneChange.bind(this);
    this.handleResetSearch = this.handleResetSearch.bind(this);
    this.handleShowTimezoneFieldChange = this.handleShowTimezoneFieldChange.bind(this);
    this.handleOrderChange = this.handleOrderChange.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.handleAccordionChange = this.handleAccordionChange.bind(this);
    this.handleDummyQuery = this.handleDummyQuery.bind(this);
    this.handleEventTypeChange = this.handleEventTypeChange.bind(this);
    this.handleTrainerChange = this.handleTrainerChange.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handleDependsCheckboxChange = this.handleDependsCheckboxChange.bind(this);
    this.handleMakeQuery = this.handleMakeQuery.bind(this);
  }

  componentDidMount() {
    const query = QueryString.parse(this.props.location.search);

    // Accepts these as URL params
    // load these with empty first elements for "any"
    let trainers = [{ first_name: 'Any', last_name: '', id: '-1' }];
    let eventTypes = [{ level: 'Any', id: '-1', public: true }];
    let trainer = -1;

    loadGMaps(() => {
      geteventTypes(true)
        .then((response) => {
          // console.log('got belt levels: ', response.data);
          // apply current cert/training type from url
          let eventType = -1;
          eventTypes = eventTypes.concat(response.data);
          eventTypes.forEach((cert, i) => {
            if (cert.level === query.type) {
              eventType = eventTypes[i].id;
            }
          });
          this.setState({
            eventTypes, // list with "any" first
            eventType,
          });
          listTrainers()
            .then((response2) => {
              // console.log('got trainers: ', response2.data);
              // apply current trainer from url
              trainers = trainers.concat(response2.data);
              this.setState({ trainers }); // Set trainers here for dev purposes TODO: REMOVE (should probably be done here anyway)
              trainers.forEach((thetrainer, i) => {
                const tName = thetrainer.first_name + ' ' + thetrainer.last_name;
                if (tName === query.trainer) {
                  // console.log('got trainer');
                  trainer = i;
                }
              });
              let {
                listView,
                address,
                attendanceType,
                // eventType,
                // day,
                // startTime,
                // endTime,
                language,
                ordering,
                // timezone,
                pageSize,
                coords,
                zoom,
              } = this.state;
              attendanceType = 'inperson'; // TODO FIX ME THIS IS A HACK

              if (query.list_view !== undefined) {
                listView = query.list_view === 'true';
              }
              // trainer = query.trainer !== undefined ? query.trainer : trainer;
              attendanceType = validAttendanceTypeByCode(query.attendance_type) ? query.attendance_type : attendanceType;
              // eventType = validEventTypeByCode(query.event_type) ? query.event_type : eventType;
              language = validLanguageByCode(query.language) ? query.language : language;
              ordering = validOrderingByCode(query.ordering) ? query.ordering : ordering;
              pageSize = query.page_size !== undefined ? query.page_size : pageSize;
              if (query.address !== undefined) {
                // LOCATION INPUT VIA URL PARAMS
                geocodeByAddress(query.address)
                  .then((results) => {
                    getLatLng(results[0])
                      .then((latLng) => {
                        coords = { latitude: latLng.lat, longitude: latLng.lng };
                        zoom = DEFAULT_ZOOM;
                        address = results[0].formatted_address;
                        // have to put this here because timing of geocode and getlatlng functions
                        this.getTrainings({
                          inListView: listView,
                          inTrainer: trainer,
                          inAddress: address,
                          inAttendanceType: attendanceType,
                          inEventType: eventType,
                          inLanguage: language,
                          inOrdering: ordering,
                          inLat: coords.lat,
                          inLng: coords.lng,
                          inPageSize: pageSize,
                        });
                        this.setState({
                          listView,
                          trainers,
                          trainer,
                          address,
                          attendanceType,
                          eventType,
                          language,
                          ordering,
                          coords,
                          zoom,
                          pageSize,
                        });
                      }).catch(error => console.error('Error', error)); //TODO
                  })
                  .catch(error => console.error('Error', error)); // TODO
              // LOCATION ACCEPTED BY USER
              } else if (global.navigator.geolocation) {
                // AIzaSyAb8zbI-E_JGFjHsCYo4_ZxPPqqz-yrNbc
                global.navigator.geolocation.getCurrentPosition(
                  // SUCCESSFULLY GOT LOCATION AUTOMATICALLY
                  (position) => {
                    // console.log('position: ', position);
                    const mycoords = {
                      latitude: position.coords.latitude,
                      longitude: position.coords.longitude,
                    };
                    // get address from coords
                    Geocode.setApiKey(GOOGLE_MAPS_API_KEY);
                    Geocode.setLanguage('en');
                    Geocode.fromLatLng(position.coords.latitude, position.coords.longitude).then(
                      (response) => {
                        address = response.results[0].formatted_address;
                        // console.log('got address: ', response.results[0]);
                        this.getTrainings({
                          inListView: listView,
                          inTrainer: trainer,
                          inAttendanceType: attendanceType,
                          inEventType: eventType,
                          inLanguage: language,
                          inOrdering: ordering,
                          inLat: mycoords.latitude,
                          inLng: mycoords.longitude,
                          inPageSize: pageSize,
                          inTrainers: trainers,
                        });
                        // console.log('setting state with address: ', address);
                        this.setState({
                          listView,
                          trainers,
                          trainer,
                          address,
                          attendanceType,
                          eventType,
                          language,
                          ordering,
                          coords: mycoords,
                          zoom: DEFAULT_ZOOM,
                          pageSize,
                        });
                      },
                      (error) => {
                        console.error(error);
                      },
                    );
                  },
                  // FAILED TO GET LOCATION AUTOMATICALLY
                  (error) => {
                    console.log(error);
                    this.getTrainings({
                      inListView: listView,
                      inTrainer: trainer,
                      inAddress: address,
                      inAttendanceType: attendanceType,
                      inEventType: eventType,
                      inLanguage: language,
                      inOrdering: ordering,
                      inLat: coords.latitude,
                      inLng: coords.longitude,
                      inPageSize: pageSize,
                      inTrainers: trainers,
                    });
                    this.setState({
                      listView,
                      trainers,
                      trainer,
                      address,
                      attendanceType,
                      eventType,
                      language,
                      ordering,
                      coords,
                      zoom: DEFAULT_ZOOM,
                      pageSize,
                    });
                  },
                );
              } else {
                // LOCATION DENIED BY USER, DEFAULT
                console.log('Geolocation is not supported by this browser.');
                this.getTrainings({
                  inListView: listView,
                  inTrainer: trainer,
                  inAttendanceType: attendanceType,
                  inEventType: eventType,
                  inLanguage: language,
                  inOrdering: ordering,
                  inLat: coords.lat,
                  inLng: coords.lng,
                  inPageSize: pageSize,
                  inTrainers: trainers,
                });
                this.setState({
                  listView,
                  trainers,
                  trainer,
                  address,
                  attendanceType,
                  eventType,
                  language,
                  ordering,
                  coords,
                  zoom,
                  pageSize,
                });
              }
            });
        })
        .catch((error2) => {
          console.error('failed to get cert levels');
          console.error(error2.response);
          this.setState({
            snackbarOpen: true,
            snackbarVariant: 'error',
            snackbarMessage: 'Something went wrong..',
          });
        });
    });
  }

  onCloseMapWindow() {
    this.setState({
      openWindow: 0,
    });
  }

  onOpenMapWindow(niaclass) { // map marker clicked
    scroller.scrollTo('scrollto' + niaclass.id, {
      duration: 200,
      delay: 100,
      smooth: true,
      offset: -180,
      containerId: 'containerElement',
    });
    this.setState({
      openWindow: niaclass.id,
    });
  }

  onResultClick(id) {
    this.setState({
      openWindow: id,
      open: false,
    });
  }

  getTrainings({
    inAttendanceType = null,
    inLat = null,
    inLng = null,
    inEventType = null,
    inTrainer = null,
    inDay = null,
    inLanguage = null,
    inPage = null,
    inOrdering = null,
    inPageSize = null,
    inTimezone = null,
    inStartDate = null,
    inEndDate = null,
    inTrainers = null,
  }) {
    const {
      attendanceType,
      eventType,
      day,
      page,
      events,
      coords,
      language,
      ordering,
      trainer,
      userTimezone,
      pageSize,
      startDate,
      endDate,
      trainers,
    } = this.state;
    // console.log('inTrainers: ', inTrainers)
    // console.log('trainers: ', trainers)
    let trainersToUse = {}
    if (inTrainers) {
      if (inTrainers.length > 0) {
        trainersToUse = inTrainers;
      }
    } else {
      trainersToUse = trainers;
    }
    // console.log('trainersToUse: ', trainersToUse)

    let attendanceTypeToUse = inAttendanceType || attendanceType;
    if (attendanceTypeToUse === 'online') {
      attendanceTypeToUse = true;
    } else {
      attendanceTypeToUse = false;
    }

    let latToUse = null;
    let lngToUse = null;
    const orderingToUse = inOrdering || ordering;
    latToUse = inLat || coords.latitude;
    lngToUse = inLng || coords.longitude;

    let eventTypeToUse = inEventType || eventType;
    if (eventTypeToUse === -1) {
      eventTypeToUse = null;
    }

    let trainerToUse = inTrainer || trainer;
    // console.log('trainer to use index: ', trainerToUse)
    if (trainerToUse === -1) {
      trainerToUse = null;
    } else {
      trainerToUse = trainersToUse[trainerToUse].id;
    }
    // console.log('trainer to use id: ', trainerToUse)

    let dayToUse = inDay !== null ? inDay : day;
    if (dayToUse === 0 || !attendanceTypeToUse) {
      dayToUse = null;
    }

    let languageToUse = inLanguage || language;
    if (languageToUse === 'any') {
      languageToUse = null;
    }

    const pageToUse = inPage || 0;

    let pageSizeToUse = inPageSize || pageSize;
    // if (pageSizeToUse === 'all') {
    //   pageSizeToUse = 10000;
    // } else {
    //   pageSizeToUse = parseInt(pageSizeToUse, 10);
    // }
    pageSizeToUse = parseInt(pageSizeToUse, 10);

    const timezoneToUse = inTimezone || userTimezone;

    let startDateToUse = inStartDate || startDate;
    if (startDateToUse === '') {
      startDateToUse = null;
    }
    let endDateToUse = inEndDate || endDate;
    if (endDateToUse === '') {
      endDateToUse = null;
    }

    getTrainings(
      attendanceTypeToUse,
      latToUse,
      lngToUse,
      eventTypeToUse,
      trainerToUse,
      timezoneToUse,
      dayToUse,
      languageToUse,
      orderingToUse,
      pageToUse,
      pageSizeToUse,
      startDateToUse,
      endDateToUse,
    )
      .then((response) => {
        // console.log('got events: ', response.data);
        this.setState({
          events: pageToUse !== page + 1 ? response.data : events.concat(response.data),
          loading: false,
          pageLoading: false,
          morePagesAvailable: response.data.length === pageSizeToUse,
          page: pageToUse,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          snackbarOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: 'Failed to load data.. please refresh the page',
        });
      });
  }

  setCenter(position) {
    const mycoords = {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
    };
    // get nearest classes after center change
    this.getTrainings({
      inLat: mycoords.latitude,
      inLng: mycoords.longitude,
    });
    this.setState({
      loading: true,
      coords: mycoords,
      zoom: DEFAULT_ZOOM,
    });
  }

  getNextPage() {
    this.setState({ pageLoading: true });
    const {
      page,
      coords,
      pageSize,
    } = this.state;
    this.getTrainings({
      inLat: coords.latitude,
      inLng: coords.longitude,
      inPage: page + 1,
      inPageSize: pageSize,
    });
  }

  handleViewToggle(e) {
    let { ordering, attendanceType } = this.state;
    if (e.target.checked) {
      // map view
      attendanceType = 'inperson';
      ordering = 'location';
      this.getTrainings({ inOrdering: ordering, inAttendanceType: attendanceType });
    } else {
      // list view
      attendanceType = 'online';
      ordering = 'time';
      this.getTrainings({ inOrdering: ordering, inAttendanceType: attendanceType });
    }
    this.setState({
      listView: !e.target.checked,
      ordering,
      attendanceType,
    });
  }

  handleLocationChange(address) {
    this.setState({ address });
  }

  handleLocationSelect(address) {
    const mycoords = {
      latitude: '',
      longitude: '',
    };
    geocodeByAddress(address)
      .then((results) => {
        this.setState({ address: results[0].formatted_address });
        getLatLng(results[0])
          .then((latLng) => {
            mycoords.latitude = latLng.lat;
            mycoords.longitude = latLng.lng;
            this.setState({
              loading: true,
              coords: mycoords,
              zoom: DEFAULT_ZOOM,
              ordering: 'location',
            });
            this.getTrainings({
              inLat: mycoords.latitude,
              inLng: mycoords.longitude,
              inOrdering: 'location',
            });
          });
      })
      .catch(error => console.error('Error', error)); // TODO
  }

  handleDrawerOpen() {
    this.setState({ open: true });
  }

  handleDrawerClose() {
    this.setState({ open: false });
  }

  handleClose(e, reason) {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ snackbarOpen: false });
  }

  handleDayChange(e) {
    // if this gets set to any day, remove start and end time filters
    let { startTime, endTime } = this.state;
    if (e.target.value === '0') {
      startTime = 0;
      endTime = 0;
    }
    this.setState({
      // loading: true,
      day: parseInt(e.target.value, 10),
      startTime,
      endTime,
      queryHasChanged: true,
    });
    // this.getTrainings({
    //   inDay: parseInt(e.target.value, 10),
    //   inPage: 0,
    // });
  }

  handleLanguageChange(e) {
    // console.log('languageChange: ', e.target.value);
    this.setState({
      // loading: true,
      language: e.target.value,
      queryHasChanged: true,
    });
    // this.getTrainings({
    //   inLanguage: e.target.value,
    //   inPage: 0,
    // });
  }

  handleResetSearch(view) {
    const { listView } = this.state;
    let attendanceType = 'inperson';
    if (listView) {
      attendanceType = 'online';
    }
    this.setState({
      attendanceType,
      trainer: -1,
      address: '',
      eventType: -1,
      day: 0,
      startTime: 0,
      endTime: 0,
      language: 'any',
      userTimezone: moment.tz.guess(),
      showTimezoneField: false,
      startDate: '',
      endDate: '',
      queryHasChanged: true,
    });
    // this.getTrainings({
    //   inAttendanceType: attendanceType,
    //   inTrainer: -1,
    //   inAddress: '',
    //   eventType: -1,
    //   inDay: 0,
    //   inStartTime: 0,
    //   inEndTime: 0,
    //   language: 'any',
    //   inUserTimezone: moment.tz.guess(),
    //   inStartDate: '',
    //   inEndDate: '',
    // });
  }

  handleTimezoneChange(event, value, reason) {
    // console.log('timezone: ', value);
    // this.getTrainings({ inTimezone: value ? value.code : '' });
    this.setState({
      userTimezone: value ? value.code : '',
      showTimezoneField: false,
      queryHasChanged: true,
    });
  }

  handleAttendanceTypeChange(e) {
    // console.log('attendance type: ', e.target.value);
    // this.getTrainings({ inAttendanceType: e.target.value });
    this.setState({
      attendanceType: e.target.value,
      queryHasChanged: true,
    });
  }

  handleShowTimezoneFieldChange(e) {
    this.setState({ showTimezoneField: true });
  }

  handleOrderChange(e) {
    // this.getTrainings({ inOrdering: e.target.value });
    this.setState({
      ordering: e.target.value,
      queryHasChanged: true,
    });
  }

  handlePageSizeChange(inSize) {
    // this.getTrainings({
    //   inPageSize: inSize,
    // });
    this.setState({
      pageSize: inSize,
      queryHasChanged: true,
    });
  }

  handleAccordionChange(e) {
    const { expanded } = this.state;
    this.setState({
      expanded: !expanded,
    });
  }

  handleMakeQuery() {
    this.setState({
      // loading: true,
      queryHasChanged: false,
    });
    // this.handleDrawerClose();
    this.getTrainings({});
  }

  handleTrainerChange(e) {
    // this.getTrainings({
    //   inPage: 0,
    //   inTrainer: parseInt(e.target.value, 10), // index not id
    // });
    this.setState({
      // loading: true,
      trainer: parseInt(e.target.value, 10), // index not id
      queryHasChanged: true,
    });
  }

  handleEventTypeChange(e) {
    this.setState({
      // loading: true,
      eventType: parseInt(e.target.value, 10),
      queryHasChanged: true,
    });
    // this.getTrainings({
    //   inEventType: parseInt(e.target.value, 10),
    //   inPage: 0,
    // });
  }

  handleStartDateChange(e) {
    // console.log(e.target.value);
    // this.getTrainings({ inStartDate: e.target.value });
    this.setState({
      startDate: e.target.value,
      queryHasChanged: true,
    });
  }

  handleEndDateChange(e) {
    // console.log(e.target.value);
    // this.getTrainings({ inEndDate: e.target.value });
    this.setState({
      endDate: e.target.value,
      queryHasChanged: true,
    });
  }

  handleDummyQuery(e) {
    e.preventDefault();
  }

  handlePopupOpen(e, dependsOnText, dependsOnCheckbox, dependsLink) {
    this.setState({
      popupAnchor: e.currentTarget,
      popupOpen: true,
      dependsOnText,
      dependsOnCheckbox,
      dependsLink,
    });
  }

  handlePopupClose() {
    this.setState({
      popupAnchor: null,
      popupOpen: false,
      dependsOnText: '',
      dependsOnCheckbox: '',
      dependsLink: '',
      dependsChecked: false,
    });
  }

  handleDependsCheckboxChange(event) {
    this.setState({
      dependsChecked: event.target.checked,
    });
  }

  render() {
    const { classes } = this.props;
    const {
      attendanceType,
      listView,
      coords,
      zoom,
      events,
      snackbarOpen,
      snackbarVariant,
      snackbarMessage,
      address,
      openWindow,
      open,
      loading,
      pageLoading,
      morePagesAvailable,
      day,
      userTimezone,
      language,
      ordering,
      showTimezoneField,
      pageSize,
      expanded,
      trainer,
      trainers,
      eventType,
      eventTypes,
      startDate,
      endDate,
      popupOpen,
      dependsOnText,
      dependsOnCheckbox,
      dependsLink,
      dependsChecked,
      popupAnchor,
      queryHasChanged,
    } = this.state;

    const sortByDisabled = attendanceType === 'online' || address === '';
    const meetsOnDayHidden = attendanceType === 'inperson';

    return (
      <div className={classes.layout}>

        <Helmet>
          <title>Nia Trainings Finder | So Much More Than a Dance Workout</title>
          <meta name="description" content="Nia's training finder helps you find the right course for your journey into complete wellness for the mind, body, and soul. Get started here." />
          <meta name="keywords" content="dance, workout, online" />
        </Helmet>

        {/* NAVBAR */}
        <NavBar
          open={open}
          handleDrawerOpen={this.handleDrawerOpen}
        />
        <div className={open ? classes.wrapperOpen : classes.wrapperClosed}>
          { listView
            ? (
              <React.Fragment>
                <ListSearchPanel
                  open={open}
                  handleDrawerClose={this.handleDrawerClose}
                  handleDrawerOpen={this.handleDrawerOpen}
                  checked={!listView}
                  handleViewToggle={this.handleViewToggle}
                  listItems={events}
                  currenteventType={eventType}
                  currentDay={day}
                  handleDayChange={this.handleDayChange}
                  handleResetSearch={this.handleResetSearch}
                  timezone={userTimezone}
                  handleTimezoneChange={this.handleTimezoneChange}
                  handleMakeQuery={this.handleMakeQuery}
                  loading={loading}
                  attendanceType={attendanceType}
                  handleAttendanceTypeChange={this.handleAttendanceTypeChange}
                  language={language}
                  handleLanguageChange={this.handleLanguageChange}
                  showTimezoneField={showTimezoneField}
                  handleShowTimezoneFieldChange={this.handleShowTimezoneFieldChange}
                  ordering={ordering}
                  handleOrderChange={this.handleOrderChange}
                  pageSize={pageSize}
                  handlePageSizeChange={this.handlePageSizeChange}
                  handleDummyQuery={this.handleDummyQuery}
                  eventTypes={eventTypes}
                  eventType={eventType}
                  handleEventTypeChange={this.handleEventTypeChange}
                  trainer={trainer}
                  trainers={trainers}
                  handleTrainerChange={this.handleTrainerChange}
                  startDate={startDate}
                  handleStartDateChange={this.handleStartDateChange}
                  endDate={endDate}
                  handleEndDateChange={this.handleEndDateChange}
                  sortByDisabled={sortByDisabled}
                  meetsOnDayHidden={meetsOnDayHidden}
                  address={address}
                  handleLocationChange={this.handleLocationChange}
                  handleLocationSelect={this.handleLocationSelect}
                  queryHasChanged={queryHasChanged}
                />
                <ListComponent
                  loading={loading}
                  pageLoading={pageLoading}
                  events={events}
                  attendanceType={attendanceType}
                  userTimezone={userTimezone}
                  currentDay={days[day]}
                  getNextPage={this.getNextPage}
                  morePagesAvailable={morePagesAvailable}
                  ordering={ordering}
                  handlePopupOpen={this.handlePopupOpen}
                />
              </React.Fragment>
            )
            : (
              <React.Fragment>
                <MapSearchPanel
                  open={open}
                  handleDrawerClose={this.handleDrawerClose}
                  handleDrawerOpen={this.handleDrawerOpen}
                  address={address}
                  listItems={events}
                  handleLocationChange={this.handleLocationChange}
                  handleLocationSelect={this.handleLocationSelect}
                  onResultClick={this.onResultClick}
                  active={openWindow}
                  checked={!listView}
                  handleViewToggle={this.handleViewToggle}
                  loading={loading}
                  pageLoading={pageLoading}
                  getNextPage={this.getNextPage}
                  morePagesAvailable={morePagesAvailable}
                  currentEventType={eventType}
                  attendanceType={attendanceType}
                  handleAttendanceTypeChange={this.handleAttendanceTypeChange}
                  handleResetSearch={this.handleResetSearch}
                  language={language}
                  handleLanguageChange={this.handleLanguageChange}
                  ordering={ordering}
                  handleOrderChange={this.handleOrderChange}
                  pageSize={pageSize}
                  handlePageSizeChange={this.handlePageSizeChange}
                  expanded={expanded}
                  handleAccordionChange={this.handleAccordionChange}
                  eventTypes={eventTypes}
                  handleEventTypeChange={this.handleEventTypeChange}
                  trainer={trainer}
                  trainers={trainers}
                  handleTrainerChange={this.handleTrainerChange}
                  startDate={startDate}
                  handleStartDateChange={this.handleStartDateChange}
                  endDate={endDate}
                  handleEndDateChange={this.handleEndDateChange}
                  handlePopupOpen={this.handlePopupOpen}
                  queryHasChanged={queryHasChanged}
                  handleMakeQuery={this.handleMakeQuery}
                />
                <div className={classes.content}>
                  <div className={classes.appBarSpacer} />
                  {/* MAP */}
                  <MapComponent
                    googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places"
                    loadingElement={<div style={{ height: 'calc(100vh - 64px)' }} />} // the calc(100vh - 64px) is making room for the appbar
                    containerElement={<div style={{ height: 'calc(100vh - 64px)' }} />}
                    mapElement={<div style={{ height: 'calc(100vh - 64px)' }} />}
                    coords={coords}
                    attendanceType={attendanceType}
                    zoom={zoom}
                    events={events}
                    onOpenMapWindow={this.onOpenMapWindow}
                    onCloseMapWindow={this.onCloseMapWindow}
                    openWindow={openWindow}
                    loading={loading}
                    handlePopupOpen={this.handlePopupOpen}
                  />
                </div>
              </React.Fragment>
            )
          }
          {/* POPOVER */}
          <MyPopOver
            popupOpen={popupOpen}
            handlePopupClose={this.handlePopupClose}
            dependsOnText={dependsOnText}
            dependsChecked={dependsChecked}
            handleDependsCheckboxChange={this.handleDependsCheckboxChange}
            dependsOnCheckbox={dependsOnCheckbox}
            dependsLink={dependsLink}
            popupAnchor={popupAnchor}
          />
          {/* SNACKBAR */}
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            open={snackbarOpen}
            autoHideDuration={5000}
            onClose={this.handleClose}
          >
            <MySnackbarContentWrapper
              onClose={this.handleClose}
              variant={snackbarVariant}
              message={snackbarMessage}
            />
          </Snackbar>
        </div>
      </div>
    );
  }
}

Finder.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Finder);
